import { Link } from "react-router-dom";
import { List, ListInlineItem } from "reactstrap";
import { SOCIAL_DATA } from "../../../../Data/Bonus Ui/Tour";
import { CommonTourSocialMediaProp } from "../../../../Type/BonusUi";

const CommonTourSocialMedia = ({ time,className }: CommonTourSocialMediaProp) => {
  return (
    <div className={`social-media ${time ? "social-tour" : ""} ${className ? className : ""}`}>
      <List type="inline" className="align-items-center">
        {SOCIAL_DATA.map(({ href, icon }, index) => (
          <ListInlineItem key={index}>
            <Link to={href} target="_blank">
              <i className={`fa fa-${icon}`}></i>
            </Link>
          </ListInlineItem>
        ))}
        {time && (
          <div className="float-sm-end">
            <small>{time}</small>
          </div>
        )}
      </List>
    </div>
  );
};

export default CommonTourSocialMedia;
